import { Injectable } from '@angular/core';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { GpAuthService } from 'gp-auth';
import { map, Observable, tap } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { LoadCurrentUser, ProfileState } from 'shared';

@Injectable()
export class AuthGuard {
  constructor(private store: Store, private authService: GpAuthService) {
  }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    const isAuthenticated = this.store.select(ProfileState.currentUser);
    return isAuthenticated.pipe(
      tap(user => {
        if (!user) {
          if (this.authService.getToken()) {
            // this.store.dispatch(new LoadCurrentUser());
          } else {
            this.store.dispatch(new Navigate(['/auth/login']));
          }
        }
      }),
      filter(user => !!user),
      take(1),
      tap(isAuth => {
        if (!isAuth) {
          this.store.dispatch(new Navigate(['/auth/login']));
        }
      }),
      map(isAuth => !!isAuth)
    );
  }
}
